import { Component, OnDestroy, OnInit,} from '@angular/core';
import {of, Subject, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';

import {EditModalService} from '../../services/edit-modal.service';
import {MyDeviceRequestContainerModel} from '../../models/my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from '../../models/my-not-device-request-container.model';
import {ProductCategoryTypeEnum} from '../../enums/product-category-type.enum';
import {MyContainerSharedMetadataModel} from '../../models/my-container-shared-metadata.model';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

/*
 *  dialog for the 5.step page, where is possible to add general supplies
 *  to general supp order list form categorized list
 */
@Component({
    selector: 'app-add-supply-categorised-modal',
    templateUrl: './add-supply-categorised-modal.component.html',
    styleUrls: ['./add-supply-categorised-modal.component.scss']
})
export class AddSupplyCategorisedModalComponent extends ModalDialogV3 implements OnInit, OnDestroy {

    // @ViewChild('searchInput') searchInput: ElementRef;

    private searchTerm = new Subject<string>();
    private searchTermSub: Subscription;

    public searchPhrase: string;
    public categorisedWithParentSupplies: MyDeviceRequestContainerModel[];
    public filteredCategorisedWithParentSupplies: MyDeviceRequestContainerModel[];

    public allSupplies: MyNotDeviceRequestContainerModel[];  // not device like... only array of all supplies
    public filteredAllSupplies: MyNotDeviceRequestContainerModel[];

    // tslint:disable-next-line:max-line-length
    public notDeviceCategory: MyDeviceRequestContainerModel;  // emulated device used to keep the same html like device logic
    public isSpinnerVisible = false;


    constructor( public editModalService: EditModalService) {
        super();
    }

    public async ngOnInit() {
        await this.init();
    }

    public async init() {
        // this.categorisedWithParentSupplies = (await this.editModalService.getCategorizedSupplyOrderItems() )
        //     .filter( deviceContainer => deviceContainer.supplies && deviceContainer.supplies.length > 0);
        const dialogModel = this.editModalService.getDialogModel();

        // remove brotherCustomProducts supplies and those supplies which should not be visible for chanel partners users
        const containersWithoutBrotherCustomProducts: MyDeviceRequestContainerModel[] = [...dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers];

        for (let i = 0; i < containersWithoutBrotherCustomProducts.length; i++) {
            containersWithoutBrotherCustomProducts[i] = {...containersWithoutBrotherCustomProducts[i]};
            containersWithoutBrotherCustomProducts[i].supplies = containersWithoutBrotherCustomProducts[i].supplies.filter(supply => !supply.itemToOrder.brotherCustomProduct);
            // https://minntgmbh.atlassian.net/browse/BROT-1861
            containersWithoutBrotherCustomProducts[i].supplies = containersWithoutBrotherCustomProducts[i].supplies.filter(supply => supply.itemToOrder.visibleToChannelPartners !== false);
        }
        this.categorisedWithParentSupplies = containersWithoutBrotherCustomProducts;
        this.filteredCategorisedWithParentSupplies = Object.assign([], this.categorisedWithParentSupplies);

        // https://minntgmbh.atlassian.net/browse/BROT-1918 brother custom product should be visible in list
        // this.allSupplies = dialogModel.availableSuppliesContainers.filter(supply => !supply.itemToOrder.brotherCustomProduct);
        this.allSupplies = dialogModel.availableSuppliesContainers;

        // https://minntgmbh.atlassian.net/browse/BROT-1861
        this.allSupplies = this.allSupplies.filter(supply => !supply.itemToOrder.visibleToChannelPartners === false);
        this.filteredAllSupplies = Object.assign([], this.allSupplies);

        this.notDeviceCategory = {
            containerSharedMetadata: new MyContainerSharedMetadataModel(),
            supplies: Object.assign([], this.filteredAllSupplies),
        } as MyDeviceRequestContainerModel;


        this.searchTermSub = this.searchTerm.asObservable().pipe(
            debounceTime(400),
            distinctUntilChanged(),
            switchMap((value) => of(value))
        ).subscribe(value => this.filterTableItems(value));

    }

    private filterTableItems(value: string) {

        const lowerCaseValueToSearch = value.toLocaleLowerCase();
        console.warn('filterTableItems - currently it search value inside supplies sku only and' +
            ' case sensitively , ask what it should do exactly');


        // clear all categories
        this.filteredCategorisedWithParentSupplies = [];
        // this.filteredAllSupplies = [];

        this.categorisedWithParentSupplies.forEach(deviceLikeCategory => {

            // filter device supplies and if they are some, then add category in output
            // create flat copy of variables which will be modified:
            const deviceLikeCategoryFlatCopy = Object.assign({}, deviceLikeCategory);
            deviceLikeCategoryFlatCopy.supplies = Object.assign([], deviceLikeCategory.supplies);

            // filter arrays:
            deviceLikeCategoryFlatCopy.supplies = deviceLikeCategoryFlatCopy.supplies.filter(
                supplyContainer => (supplyContainer.itemToOrder.sku.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1) ||
                    (supplyContainer.itemToOrder.modelTitle.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1) ||
                    (supplyContainer.itemToOrder.modelNumber.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1)
            );
            // if some supply  comply conditions, then add category into output
            if (deviceLikeCategoryFlatCopy.supplies.length) {
                deviceLikeCategoryFlatCopy.containerSharedMetadata.isSupplyCategoryExpanded = true; // open category
                this.filteredCategorisedWithParentSupplies.push(deviceLikeCategoryFlatCopy);
            }
        });

        this.filteredAllSupplies = this.allSupplies.filter(supply =>
            (supply.itemToOrder.sku.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1) ||
            (supply.itemToOrder.modelTitle.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1) ||
            (supply.itemToOrder.modelNumber.toLocaleLowerCase().indexOf(lowerCaseValueToSearch) > -1)
        );

        this.notDeviceCategory.supplies = this.filteredAllSupplies;

    }

    public onCancelBtnClicked() {
        // this.categorisedWithParentSupplies is shortcut for dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers
        // this.allSupplies is shortcut for dialogModel.availableSuppliesContainers;
        // both are accessible via dialogModel
        this.announceModelChanged({
            action: 'RESET',
            dialogModel: {categorisedOrderItems: this.categorisedWithParentSupplies, noParentSupplies: this.allSupplies}
        });
        super.close();
    }

    public onSubmitBtnClicked() {
        this.announceModelChanged({
            action: 'SUBMIT',
            dialogModel: {categorisedOrderItems: this.categorisedWithParentSupplies, noParentSupplies: this.allSupplies}
        });
        this.close();
    }


    public onCategoryClicked(categoryContainer: MyDeviceRequestContainerModel, showSpinner = false) {
        if (showSpinner) {
            this.isSpinnerVisible = !categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded;
            setTimeout(_ => {
                // tslint:disable-next-line:max-line-length
                categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded = !categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded;
                this.isSpinnerVisible = false;
            }, 20);
        } else {
            // tslint:disable-next-line:max-line-length
            categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded = !categoryContainer.containerSharedMetadata.isSupplyCategoryExpanded;
        }


    }

    public announceSearchTermChanged(term: string) {
        this.searchTerm.next(term);
    }

    public ngOnDestroy(): void {
        this.searchTermSub.unsubscribe();
    }

    isWarranty(supplyContainer: MyNotDeviceRequestContainerModel) {
        return ProductCategoryTypeEnum[supplyContainer.itemToOrder.category] === ProductCategoryTypeEnum.WARRANTY;
    }
}
